export default function getIsHqAdmin(state: any) {
  return state.getIn(['currentUser', 'data', 'isHqAdmin'], false);
}
